<template>
  <div class="container ml-1">
    <div class="card my-3">
      <div class="card-header d-flex align-items-center bg-primary text-light">
        <div class="mr-auto">Create, Edit, or Delete Office Message</div>
        <a href="#back" @click.prevent="$router.go(-1)">
          <svg-icon class="am-glyphicon-medium am-glyphicon-white" icon="back" title="Back"></svg-icon>
        </a>
      </div>
      <b-navbar variant="light">
        <b-navbar-nav class="mr-auto"></b-navbar-nav>
        <b-btn size="sm" variant="success" @click="openAddModal()">Create</b-btn>
      </b-navbar>
      <div class="card-body">
        <loading-overlay :show="busy"></loading-overlay>
        <div class="text-center font-weight-bold" v-if="fetchOffices.length === 0">No Office Messages</div>
        <table class="table table-sm table-bordered table-striped" v-else="v-else">
          <thead class="thead-dark">
          <tr>
            <th @click="sort('office.name')" class="am-office-messages-th">Office<span><img v-if="sortData.currentSort === 'office.name'" :src="sorterArrow"></span></th>
            <th @click="sort('message')" class="am-office-messages-th">Message<span><img v-if="sortData.currentSort === 'message'" :src="sorterArrow"></span></th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="office in officesList">
            <td class="monospace font-weight-bold">{{office.office.name | capitalize}}</td>
            <td class="monospace">{{office.message}}</td>
            <td><a class="mr-2 monospace" href="#Edit" @click="openEditModal(office)">Edit</a><a class="monospace" href="#Delete" @click="openDeleteModal(office)">Delete</a></td>
          </tr>
          </tbody>
        </table>
        <div class="am-pagination" v-show="fetchOffices.length > pageSize">
        <pagination :allData="fetchOffices" :pageSize="pageSize" :sortData="sortData" @setPageData="setPageData"></pagination>
        </div>
      </div>
      <b-modal title="Create - Office Message" ref="addModal" header-bg-variant="primary" header-text-variant="white" hide-footer="hide-footer" hide-header-close="hide-header-close" no-close-on-backdrop="no-close-on-backdrop" no-close-on-esc="no-close-on-esc">
        <create-office-message-form v-on:close="closeAddModal()" @success="handleSuccess"></create-office-message-form>
      </b-modal>
      <b-modal title="Edit - Office Message" ref="editModal" header-bg-variant="primary" header-text-variant="white" hide-footer="hide-footer" hide-header-close="hide-header-close" no-close-on-backdrop="no-close-on-backdrop" no-close-on-esc="no-close-on-esc">
        <edit-office-message-form v-if="officeSelected" :office="officeSelected" v-on:close="closeEditModal()"></edit-office-message-form>
      </b-modal>
      <b-modal title="Delete Office Message ?" header-bg-variant="primary" header-text-variant="white" ref="deleteModal" hide-footer="hide-footer" hide-header-close="hide-header-close" no-close-on-backdrop="no-close-on-backdrop" no-close-on-esc="no-close-on-esc">
        <delete-office-message-form v-if="officeSelected" :office="officeSelected" v-on:close="closeDeleteModal()"></delete-office-message-form>
      </b-modal>
    </div>
  </div>
</template>
<script>
import CreateOfficeMessageForm from '@/views/office/message/partials/CreateOfficeMessageForm'
import makesAjaxRequests from '@/mixins/makesAjaxRequests'
import EditOfficeMessageForm from '@/views/office/message/partials/EditOfficeMessageForm'
import DeleteOfficeMessageForm from '@/views/office/message/partials/DeleteOfficeMessageForm'
import api from '@/http'
import sort from '@/mixins/tableSorter'
import pagination from '@/components/pagination/pagination.vue'

export default {
  name: 'OfficeMessage',
  mixins: [makesAjaxRequests, sort],
  components: {
    CreateOfficeMessageForm,
    EditOfficeMessageForm,
    DeleteOfficeMessageForm,
    pagination
  },

  data () {
    return {
      officeSelected: null,
      pageSize: 15,
      officesList: []
    }
  },

  asyncComputed: {
    fetchOffices: {
      get() {
        return api.makeRequest('api/v1/office-message').then(resp => {
          return resp.data
        })
      },
      default: []
    }
  },

    methods: {
      setPageData (data) {
        this.officesList = data
      },
      handleSuccess() {
        this.$refs.addModal.hide()
        this.refreshList()
      },

      openAddModal() {
        this.$refs.addModal.show()
      },
      closeAddModal() {
        this.refreshList()
        this.$refs.addModal.hide()
      },
      openEditModal(office) {
        this.officeSelected = office
        this.$refs.editModal.show()
      },
      closeEditModal() {
        this.refreshList()
        this.$refs.editModal.hide()
      },
      openDeleteModal(office) {
        this.officeSelected = office
        this.$refs.deleteModal.show()
      },
      closeDeleteModal() {
        this.refreshList()
        this.$refs.deleteModal.hide()
      },
      refreshList() {
        this.$asyncComputed.fetchOffices.update()
      }
    }
  }
</script>
<style scoped>
  .am-pagination {
    padding: 10px;
    float: right;
  }

  .am-office-messages-th {
    cursor: pointer;
  }
</style>
